import * as yup from 'yup';

export const commonLetPassAccountValidation: { [x: string]: any; } = {
    companyCode: yup.string().required("Missing."),
    paymentMode: yup.string().required("Missing."),
    transactionAmount: yup.number().required("Missing.").min(0, 'Input Value should be range from 0.00 to 9,999,999,999.99.')
        .max(10000000000, 'Input Value should be range from 0.00 to 9,999,999,999.99.')

};
export const commonLetPassAccountPOValidation: { [x: string]: any; } = {
    bankCode: yup.string().required("Missing."),
    payOrderNo: yup.string().required("Missing."),
};

export const createLetPassAccountValidation: { [x: string]: any; } = {
    ...commonLetPassAccountValidation,
};
export const createLetPassAccountPOValidation: { [x: string]: any; } = {
    ...commonLetPassAccountValidation,
    ...commonLetPassAccountPOValidation,
};

export const createLetPassAccountValidationSchema = yup.object().shape(createLetPassAccountValidation);
export const createLetPassAccountPOValidationSchema = yup.object().shape(createLetPassAccountPOValidation);

